<template>
  <div class="PackageBox" id="packageTop">
    <Nav />
    <CustomMessage ref="customMessage" />
    <div class="Package">
      <!-- banner 已隐藏 -->
      <!-- 套餐购买 -->
      <div class="_tabBox">
        <div class="_tabTop">
          <li 
          v-for="(item,index) in tabList"
          :key="index"
          @click.stop="tabListActives(item.id)"
          :class="'_li ' + [tabListActive == item.id ? '_active' : '']">{{item.name}}</li>
        </div>
        <div class="_tabBot">
          <div v-if="tabListActive == 1" class="_tabBotCont1">
            <!-- 动态 IP 购买 UI -->
            <div class="dynamic-ip-package">
              <!-- 付费模式 -->
              <div class="form-row">
                <div class="row-label">
                  <span class="label-bar"></span>
                  <span class="label-text">付费模式</span>
                </div>
                <div class="row-content">
                  <div class="option-group">
                    <div 
                      v-for="(item, index) in modeList"
                      :key="index"
                      :class="['option-item', modeActive === index ? 'active' : '']"
                      @click="selectMode(index)"
                    >
                      {{ item.mode }}
                    </div>
                  </div>
                  <div class="row-tip">{{ modeActive === 1 ? '可自定义购买 IP 数量，适合大多数用户' : 'IP 时效固定，可定制每日提取数量，适合每日 IP 需求固定的用户' }}</div>
                </div>
              </div>

              <!-- 有效时长 -->
              <div class="form-row">
                <div class="row-label">
                  <span class="label-bar"></span>
                  <span class="label-text">有效时长</span>
                </div>
                <div class="row-content">
                  <div class="option-group">
                    <div 
                      v-for="(item, index) in productInfoList"
                      :key="index"
                      :class="['option-item', durationActive === index ? 'active' : '']"
                      @click="selectDuration(index)"
                    >
                      {{ item.product_name || item.name }}
                    </div>
                  </div>
                  <div class="row-tip">IP 可稳定使用时长</div>
                </div>
              </div>

              <!-- 每日 IP 使用量 / 购买 IP 量 -->
              <div class="form-row">
                <div class="row-label">
                  <span class="label-bar"></span>
                  <span class="label-text">{{ modeActive === 1 ? '购买 IP 量' : '每日 IP 使用量' }}</span>
                </div>
                <div class="row-content">
                  <div class="usage-control">
                    <div class="slider-wrapper">
                      <input 
                        type="range" 
                        :min="ipMin" 
                        :max="ipMax" 
                        :step="step"
                        v-model.number="ipNumber"
                        class="usage-slider"
                      />
                    </div>
                    <div class="usage-input-group">
                      <button class="usage-btn" @click="decreaseUsage">-</button>
                      <input type="text" :value="ipNumber" class="usage-input" readonly />
                      <button class="usage-btn" @click="increaseUsage">+</button>
                    </div>
                  </div>
                  
                  <div class="row-tip" v-if="modeActive === 1">总计可以使用的IP数量，无时间限制，超额无法提取，请根据业务需求选择总计的使用量。</div>
                  <div class="row-tip" v-else>每天可以使用的 IP 数量，超额无法提取，请根据业务需求选择每天的使用量</div>
                </div>
              </div>

              <!-- 购买时长 - 用量付费模式隐藏 -->
              <div class="form-row" v-if="modeActive === 0">
                <div class="row-label">
                  <span class="label-bar"></span>
                  <span class="label-text">购买时长</span>
                </div>
                <div class="row-content">
                  <div class="option-group">
                    <div 
                      v-for="(item, index) in purchaseDurationListShort"
                      :key="index"
                      :class="['option-item', purchaseDurationActive === index ? 'active' : '']"
                      @click="selectPurchaseDuration(index)"
                    >
                      {{ item.duration }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- 账单合计 -->
              <div class="form-row">
                <div class="row-label">
                  <span class="label-bar"></span>
                  <span class="label-text">账单合计</span>
                </div>
                <div class="row-content">
                  <div class="total-price">￥{{ totalPrice }}</div>
                </div>
              </div>

              <div class="form-row">
                <div class="row-label">
                  <span class="label-bar"></span>
                  <span class="label-text">支付类型</span>
                </div>
                <div class="row-content">
                  <div class="payment-group">
                    <div 
                      :class="['payment-item', paymentActive == '1' ? 'active' : '']"
                      @click="paymentActive = '1'"
                    >
                      <img src="../assets/zfb.png" alt="支付宝">
                      <p>支付宝</p>
                    </div>
                    <div 
                      :class="['payment-item', paymentActive == '3' ? 'active' : '']"
                      @click="paymentActive = '3'"
                    >
                      <img src="../assets/km2.png" alt="余额支付">
                      <p>余额支付</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 提交订单 -->
              <div class="submit-row">
                <button class="submit-btn" @click="submitOrder">
                  提交订单
                </button>
              </div>
            </div>
            
            <!-- 短效代理套餐优势 -->
            <div class="_tabAdvantage">
              <h3>短效代理套餐的优势</h3>
              <div class="_advantageCont">
                <div class="_advantageCont_left">
                  <span>1. 高匿 IP 可用率 99%</span>
                  <span>2. 支持 HTTP/HTTPS/SOCKS5</span>
                  <span>3. 按提取量计费</span>
                  <span>4. 并发提取最多 359 个/次，API 最快调用频率 30 次/s</span>
                  <span>5. 支持多种验证方式：IP 白名单授权或用户名密码认证</span>
                </div>
                <div class="_advantageCont_cent">短<br>效<br>优<br>势</div>
                <div class="_advantageCont_right">
                  <span>6. IP 支持多点同时使用</span>
                  <span>7. 支持 IP 去重、地区混播，主动去重时间间隔≧5min</span>
                  <span>8. IP 共享在线 IP 池巨大</span>
                  <span>9. 带宽高，延迟低，秒连秒换</span>
                  <span>10. 7x24 小时全天售后</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tabListActive == 2" class="_tabBotCont2">
            <div class="_tabList">
              <li 
              :class="'_li ' + [tabreadPackageActive == index ? '_active' : ''] "
              v-for="(item,index) in readPackageList"
              :key="index"
              >
                <div class="_ttop">
                  <span>{{item.product_name}}</span>
                </div>
                <div class="_ccont">
                  <span class="_price">￥{{(item.price / 1000).toFixed(2)}}</span>
                </div>
                <div class="_bbot">
                  <span class="_lineCount">线路数量</span>
                  <el-input-number 
                    class="_num" 
                    v-model="item.num" 
                    @change="handleChange" 
                    :min="0" 
                    :max="item.ip_count" 
                    label="描述文字"
                  ></el-input-number>
                  <p class="_botton" @click.stop="_detection(item)">立即购买</p>
                </div>
              </li>
            </div>
            <div class="_tabAdvantage">
              <h3>独享代理套餐的优势</h3>
              <div class="_advantageCont">
                <div class="_advantageCont_left">
                  <span>1. 高匿 IP 可用率 98%</span>
                  <span>2. 支持 HTTP/HTTPS/SOCKS5</span>
                  <span>3. 时效自由 根据实际业务自己控制单个 IP 使用时长</span>
                  <span>4. 并发数量自由选择 根据客户购买数量决定 </span>
                  <span>5. 支持多种验证方式：IP 白名单授权或用户名密码认证 </span>
                  <span>6. 单个代理 IP 支持多点同时使用</span>
                </div>
                <div class="_advantageCont_cent">独<br>享<br>优<br>势</div>
                <div class="_advantageCont_right">
                  <span>7. 支持 IP 去重 地区混播</span>
                  <span>8. IP 独享唯一在线 IP 池巨大</span>
                  <span>9. 带宽高 延迟低 秒连秒换 不限流量</span>
                  <span>10. 单条线路不限制每日提取 IP 总数（单条线路=1 并发）</span>
                  <span>11. 7x24 小时全天售后</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 大客户定制已隐藏 -->
          <!-- <div v-if="tabListActive == 3" class="_tabBotCont3">
            <div class="enterprise-custom">
              <div class="custom-icon">🤝</div>
              <h3>大客户定制服务</h3>
              <p class="custom-desc">为企业客户提供专属定制方案，包括：</p>
              <ul class="custom-list">
                <li>专属 IP 资源池</li>
                <li>定制化 API 接口</li>
                <li>7×24 小时技术支持</li>
                <li>灵活计费方案</li>
                <li>数据安全保障</li>
              </ul>
              <div class="custom-contact">
                <p>请联系我们的销售团队获取详细方案</p>
                <button class="contact-btn" @click="contactSales">联系售前</button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import CustomMessage from '@/components/Message.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'Package',
  components: {
    Nav,
    Foot,
    CustomMessage
  },
  data(){
    return {
      num:1,
      tabList:[
        {name:'短效代理购买',id:1},
        {name:'独享代理套餐',id:2},
        // {name:'大客户定制',id:3}, // 已隐藏
      ],
      tabListActive:1,
      productInfoList:[],
      productInfoActive:null,
      readPackageList:[],
      tabreadPackageActive:null,
      
      // 动态 IP 购买数据
      modeList: [], // 付费模式列表
      modeActive: null, // 选中模式的 index
      durationActive: 0, // 有效时长选中 index
      minUsage: 1000,
      maxUsage: 10000,
      dailyUsage: 1000,
      step: 1000, // 固定步长 1000
      purchaseDurationListShort: [], // 购买时长列表
      purchaseDurationActive: 0,
      paymentActive: '1',
      totalPrice: 0,
      cdkeyText: '',
      // 特殊字段
      ipMax: 10000,
      ipMin: 1000,
      ipNumber: 1000,
      // 保存原始完整数据（用于切换模式时过滤）
      allProductList: []
    }
  },
  created(){
    // 初始请求 type=1（动态 IP）
    this.getProductInfo(1)
  },
  mounted(){
    new WOW().init();
  },
  watch: {
    ipNumber() { this.calculatePrice(); },
    purchaseDurationActive() { this.calculatePrice(); },
    modeActive() { this.calculatePrice(); },
    durationActive() { this.calculatePrice(); }
  },
  methods:{
    // 选择付费模式 - 重置后面所有选项并过滤数据
    selectMode(index) {
      this.modeActive = index;
      const selectedMode = this.modeList[index];
      const modeId = selectedMode?.mode_id;
      
      // 根据选中的 mode_id 过滤有效时长列表
      const allProductList = this.getAllProductList();
      this.productInfoList = allProductList.filter(item => item.mode_id === modeId);
      
      // 重置有效时长为第一个
      this.durationActive = 0;
      
      // 根据过滤后的有效时长列表过滤购买时长列表
      this.updatePurchaseDurationList();
      
      // 重置 IP 使用量（会触发价格计算）
      this.resetIPUsage();
      
      // 用量付费模式清空购买时长
      if (index === 1) {
        this.purchaseDurationActive = null;
      }
    },
    // 选择有效时长 - 重置后面所有选项
    selectDuration(index) {
      this.durationActive = index;
      // 根据选中的有效时长过滤购买时长列表
      this.updatePurchaseDurationList();
      // resetIPUsage 会修改 ipNumber，触发 watch 自动计算价格
      this.resetIPUsage();
    },
    // 选择购买时长 - 不重置 IP 使用量
    selectPurchaseDuration(index) {
      this.purchaseDurationActive = index;
    },
    // 更新购买时长列表（根据当前选中的有效时长）
    updatePurchaseDurationList() {
      const selectedDuration = this.productInfoList[this.durationActive];
      if (selectedDuration && selectedDuration.price && selectedDuration.price.length > 0) {
        this.purchaseDurationListShort = selectedDuration.price.map(priceItem => ({
          duration: priceItem.duration,
          id: priceItem.id,
          price: priceItem.price, // 价格字段（单位：厘）
          price_id: priceItem.id, // price_id = id 字段
          shortterm_id: priceItem.shortterm_id,
          unit: priceItem.unit
        }));
        // 重置购买时长选中索引为第一个
        this.purchaseDurationActive = 0;
      } else {
        // 如果没有购买时长数据，清空列表
        this.purchaseDurationListShort = [];
        this.purchaseDurationActive = null;
      }
    },
    // 获取所有有效时长列表（用于过滤）
    getAllProductList() {
      return this.allProductList;
    },
    // 重置 IP 使用量为默认值
    resetIPUsage() {
      const selectedDuration = this.productInfoList[this.durationActive];
      if (selectedDuration) {
        this.ipMin = selectedDuration.ip_min || 1000;
        this.ipMax = selectedDuration.ip_max || 10000;
      }
      this.ipNumber = this.ipMin;
      this.step = 1000;
    },
    // 计算价格
    calculatePrice() {
      const selectedDuration = this.productInfoList[this.durationActive];
      const selectedPurchaseDuration = this.purchaseDurationListShort[this.purchaseDurationActive];
      
      let priceInLi = 0; // 价格单位：厘
      
      if (this.modeActive === 0) {
        // 时长付费模式：价格 = 每日 ip 使用量 * 购买时长价格
        const purchasePrice = selectedPurchaseDuration?.price || 0;
        priceInLi = this.ipNumber * purchasePrice;
      } else if (this.modeActive === 1) {
        // 用量付费模式：价格 = 每日 ip 使用量 * 有效时长对应的 ip_price
        const ipPrice = selectedDuration?.ip_price || 0;
        priceInLi = this.ipNumber * ipPrice;
      }
      
      // 转换为元（除以 1000），保留 2 位小数，只用于显示
      this.totalPrice = (priceInLi / 1000).toFixed(2);
    },
    // IP 使用量控制
    increaseUsage() {
      if (this.ipNumber < this.ipMax) {
        this.ipNumber += this.step;
        if (this.ipNumber > this.ipMax) this.ipNumber = this.ipMax;
      }
    },
    decreaseUsage() {
      if (this.ipNumber > this.ipMin) {
        this.ipNumber -= this.step;
        if (this.ipNumber < this.ipMin) this.ipNumber = this.ipMin;
      }
    },
    // 提交订单
    submitOrder() {
      // 检查登录状态
      const access_token = localStorage.getItem('access_token')
      if(!access_token){
        // 弹出登录框
        this.$store.commit('setLoginType', true)
        this.$store.commit('setRegisterType', '1')
        return
      }
      
      // 打印所选的对应 ID
      const selectedMode = this.modeList[this.modeActive];
      const selectedDuration = this.productInfoList[this.durationActive];
      const selectedPurchaseDuration = this.purchaseDurationListShort[this.purchaseDurationActive];
      
      // 计算金额（单位：厘）
      let priceInLi = 0;
      if (this.modeActive === 0) {
        // 时长付费模式：价格 = 每日 ip 使用量 * 购买时长价格
        const purchasePrice = selectedPurchaseDuration?.price || 0;
        priceInLi = this.ipNumber * purchasePrice;
      } else if (this.modeActive === 1) {
        // 用量付费模式：价格 = 每日 ip 使用量 * 有效时长对应的 ip_price
        const ipPrice = selectedDuration?.ip_price || 0;
        priceInLi = this.ipNumber * ipPrice;
      }
      
      console.log('===== 提交订单数据 =====');
      console.log('付费模式 mode_id:', selectedMode?.mode_id);
      console.log('有效时长 short_id:', selectedDuration?.id);
      // 用量付费模式（modeActive=1）不提交购买时长
      if (this.modeActive === 0) {
        console.log('购买时长 price_id:', selectedPurchaseDuration?.price_id);
      } else {
        console.log('购买时长 price_id: 用量付费模式无需此字段');
      }
      console.log('每日 IP 使用量 ip_number:', this.ipNumber);
      console.log('支付类型 pay_type:', this.paymentActive);
      console.log('购买时长价格 purchasePrice:', selectedPurchaseDuration?.price);
      console.log('IP 单价 ip_price:', selectedDuration?.ip_price);
      console.log('金额 amount (厘):', priceInLi);
      console.log('========================');
      
      // 构建提交数据
      let data = {
        mode_id: selectedMode?.mode_id,
        short_id: selectedDuration?.id,
        ip_number: this.ipNumber,
        pay_type: this.paymentActive, // 1=支付宝，3=余额
        amount: priceInLi, // 金额，单位：厘，数字格式
        access_token: localStorage.getItem('access_token')
      };
      
      // 用量付费模式（modeActive=1）不提交购买时长
      if (this.modeActive === 0) {
        data.price_id = selectedPurchaseDuration?.price_id;
      }
      
      console.log('提交数据:', data);
      
      // 根据套餐类型选择接口：1=动态 IP，2=独享套餐
      const isDynamicIP = this.tabListActive === 1;
      const orderApi = isDynamicIP ? Apis.orderShort : Apis.orderExclusive;
      const bdData = localStorage.getItem('bdData') ? JSON.parse(localStorage.getItem('bdData')) : null
			console.log(bdData, 'bdData')
      if (bdData) {
				data.bd_vid = bdData.bd_vid
				data.bd_url = bdData.bd_url
			}
      // 调用订单接口
      request({
        method: "get",
        url: orderApi,
        params: data,
        _type: 1
      }).then(res => {
        // code: -10 表示需要实名认证
        if (res.code === -10) {
          this.$confirm(res.msg || '需要实名认证', '提示', {
            confirmButtonText: '前往实名',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            // 前往实名：跳转到个人中心实名认证页
            this.$store.commit('setMineActiveLi', 1)
            this.$router.push('/mine')
          }).catch(() => {
            // 取消：关闭弹窗
          });
          return;
        }
        
        if(res.code == 0){
          if (bdData) {
						localStorage.removeItem('bdData')
						this.clearBdVidNative()
					}
          // 根据 need_pay 判断：0=无需支付，1=打开支付页
          if (res.data.need_pay === 1 && res.data.payUrl) {
            // 需要支付，打开支付页
            window.open(res.data.payUrl, '_blank');
          } else {
            // 无需支付或余额支付，显示成功消息
            this.$message.success(res.msg || '购买成功');
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    clearBdVidNative() {
			const url = new URL(window.location.href)
			url.searchParams.delete('bd_vid')
			window.history.replaceState({}, '', url.href)
		},
    zfb_pay(){
      // if(this.totalPrice == ''){
      //   this.$message.error('请选择正确的金额');
      //   return;
      // }
      // if(this.totalPrice > 999999){
      //   this.$message.error('大额充值请联系客服');
      //   return;
      // }
      const access_token = localStorage.getItem('access_token');
      window.open(`${Apis.aliPay}?money=${this.totalPrice}&access_token=${access_token}`);
    },
    tabListActives(index){
      this.tabListActive = index
      // 切换套餐类型时请求对应数据：1=动态 IP，2=独享套餐
      if (index === 1) {
        this.getProductInfo(1)
      } else if (index === 2) {
        this.getProductInfo(2)
      }
    },
    handleChange(value) {
    },
    tabshortActing(index){
      this.productInfoActive = index
      if(this.productInfoActive == this.productInfoList.length+1){
        this.$store.commit("setfloatingType", true);
      }
    },
    tabreadPackage(index){
      // 如果点击的是已选中的，则取消选择并重置数量为 0
      if (this.tabreadPackageActive === index) {
        this.tabreadPackageActive = null;
        if (this.readPackageList[index]) {
          this.readPackageList[index].num = 0;
        }
      } else {
        // 选中新的，先重置所有数量为 0
        this.readPackageList.forEach(item => { item.num = 0; });
        // 然后设置选中的数量为 1
        this.tabreadPackageActive = index;
        if (this.readPackageList[index]) {
          this.readPackageList[index].num = 1;
        }
      }
    },
    // 独享套餐立即购买
    _detection(item){
      // 检查登录状态
      const access_token = localStorage.getItem('access_token')
      if(!access_token){
        // 弹出登录框
        this.$store.commit('setLoginType', true)
        this.$store.commit('setRegisterType', '1')
        return
      }
      
      if (!item || !item.id) {
        this.$message.error('请选择套餐');
        return;
      }
      if (!item.num || item.num <= 0) {
        this.$message.error('请输入购买数量');
        return;
      }
      
      // 构建提交数据：只传 exclusive_id、数量、金额（单位：厘）
      let data = {
        exclusive_id: item.id,
        number: item.num,
        amount: item.price * item.num, // 金额 = 单价 * 数量，单位：厘
        access_token: localStorage.getItem('access_token')
      };
      
      console.log('独享套餐提交数据:', data);
      const bdData = localStorage.getItem('bdData') ? JSON.parse(localStorage.getItem('bdData')) : null
			console.log(bdData, 'bdData')
      if (bdData) {
				data.bd_vid = bdData.bd_vid
				data.bd_url = bdData.bd_url
			}
      // 调用独享套餐订单接口
      request({
        method: "get",
        url: Apis.orderExclusive,
        params: data,
        _type: 1
      }).then(res => {
        // code: -10 表示需要实名认证
        if (res.code === -10) {
          this.$confirm(res.msg || '需要实名认证', '提示', {
            confirmButtonText: '前往实名',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            // 前往实名：跳转到个人中心实名认证页
            this.$store.commit('setMineActiveLi', 1)
            this.$router.push('/mine')
          }).catch(() => {
            // 取消：关闭弹窗
          });
          return;
        }
        
        if(res.code == 0){
          if (bdData) {
						localStorage.removeItem('bdData')
						this.clearBdVidNative()
					}
          // 根据 need_pay 判断：1=打开支付页，其他显示成功消息
          if (res.data.need_pay === 1 && res.data.payUrl) {
            window.open(res.data.payUrl, '_blank');
          } else {
            this.$message.success(res.msg || '购买成功');
            setTimeout(() => {
              this.$router.go(0);
            }, 2000);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getProductInfo(type = 1){
      let data = { type: type }
      request({
        method: "get", 
        url: Apis.readProductList,
        params:data,
        _type:1,
      }).then(res => {
        if(res.code == 0){
          // type=1 动态 IP，type=2 独享套餐
          if (type === 1) {
            // 解析动态 IP 套餐数据 - 数据结构是嵌套的
            // res.data = [{mode, mode_id, item: [{id, product_id, mode, valid_duration, ip_price, ip_min, ip_max, price: [{id, shortterm_id, duration, unit, price}]}]}]
            const modeDataList = res.data || [];
            
            // 1. 提取付费模式列表
            this.modeList = modeDataList.map(item => ({
              mode: item.mode,
              mode_id: item.mode_id
            }));
            // 设置默认选中的付费模式
            this.modeActive = 0;
            
            // 2. 提取有效时长列表（从 item 数组）- 保存完整数据包含 mode_id
            const productList = [];
            modeDataList.forEach(modeItem => {
              if (modeItem.item && Array.isArray(modeItem.item)) {
                modeItem.item.forEach(item => {
                  productList.push({
                    id: item.id,
                    product_name: item.product_name, // 有效时长显示字段
                    product_id: item.product_id,
                    mode_id: modeItem.mode_id, // 保存 mode_id 用于过滤
                    mode: item.mode,
                    ip_min: item.ip_min,
                    ip_max: item.ip_max,
                    ip_price: item.ip_price,
                    price: item.price || [] // 购买时长列表
                  });
                });
              }
            });
            this.allProductList = productList; // 保存完整数据
            // 默认只显示第一个付费模式对应的有效时长
            const firstModeId = this.modeList[0]?.mode_id;
            this.productInfoList = productList.filter(item => item.mode_id === firstModeId);
            
            // 3. 提取购买时长列表（从第一个有效时长的 price 数组）
            if (productList.length > 0 && productList[0].price && Array.isArray(productList[0].price)) {
              this.purchaseDurationListShort = productList[0].price.map(priceItem => ({
                duration: priceItem.duration,
                id: priceItem.id,
                price: priceItem.price, // 价格字段（单位：厘）
                price_id: priceItem.id, // price_id = id 字段
                shortterm_id: priceItem.shortterm_id,
                unit: priceItem.unit
              }));
              // 设置购买时长默认选中第一个
              this.purchaseDurationActive = 0;
            } else {
              this.purchaseDurationListShort = [];
              this.purchaseDurationActive = null;
            }
            
            // 4. 提取 IP 使用量范围（取第一个数据）
            if (productList.length > 0) {
              this.ipMax = productList[0].ip_max || 10000;
              this.ipMin = productList[0].ip_min || 1000;
              this.ipNumber = this.ipMin;
            }
            // 步长固定为 1000
            this.step = 1000;
            
            this.calculatePrice();
          } else if (type === 2) {
            // 独享套餐 - 初始化数量为 0
            this.readPackageList = (res.data || []).map(item => ({
              ...item,
              num: 0
            }));
            this.tabreadPackageActive = null;
          }
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    // contactSales(){  // 大客户定制已隐藏
    //   this.$store.commit("setfloatingType", true);
    // }
  }
}
</script>

<style lang="less" scoped>
.Package{
  width: 100%;
  min-height: 800px;
  .banner{
    width: 100%;
    height: 400px;
    background: url('../assets/banner_2.png')no-repeat;
    background-size: 100% 100%;
    h1,h3{
      width: 100%;
      color: #fff;
      text-align: center;  
      text-shadow: -2px 2px 0px #2a4fe4;
    }
    h1{
      font-size: 48px;
      font-weight: bold;
      padding-top: 130px;
    }
  }
  ._tabBox{
    width: 100%;
    ._tabTop{
      width: 900px;
      height: 50px;
      margin: 0 auto;
      margin-top: 70px;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      border: 2px solid #1F8EFF;
      ._li{
        flex: 1;
        border-right: 2px solid #1F8EFF;
        line-height: 46px;
        color: #1F8EFF;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        background: #FFFFFF;
        transition: all 0.3s ease;
      }
      ._li:last-child{
        border-right: none;
      }
      ._active{
        background: #1F8EFF;
        color: #fff;
      }
    }
    ._tabBot{
      width: 1200px;
      min-height: 300px;
      margin: 0 auto;
      margin-top: 70px;
      margin-bottom: 70px;
      
      // 动态 IP 购买样式
      .dynamic-ip-package {
        width: 100%;
        max-width: 1000px;
        margin: 0 auto;
        padding: 40px 20px;
        
        .form-row {
          display: flex;
          margin-bottom: 30px;
          align-items: flex-start;
          
          .row-label {
            width: 140px;
            display: flex;
            align-items: center;
            flex-shrink: 0;
            
            .label-bar {
              width: 4px;
              height: 16px;
              background: #1F8EFF;
              margin-right: 10px;
            }
            
            .label-text {
              font-size: 14px;
              font-weight: 500;
              color: #333;
            }
          }
          
          .row-content {
            flex: 1;
            text-align: left;
            
            .row-tip {
              font-size: 12px;
              color: #999;
              margin-top: 8px;
              line-height: 1.5;
            }
          }
        }
        
        .option-group {
          display: flex;
          gap: 12px;
          
          .option-item {
            padding: 10px 24px;
            background: #FFFFFF;
            border: 1px solid #E4E7ED;
            border-radius: 4px;
            font-size: 14px;
            color: #666;
            cursor: pointer;
            transition: all 0.3s ease;
            
            &:hover {
              border-color: #1F8EFF;
              color: #1F8EFF;
            }
            
            &.active {
              background: #1F8EFF;
              border-color: #1F8EFF;
              color: #FFFFFF;
            }
          }
        }
        
        .usage-control {
          display: flex;
          align-items: center;
          gap: 20px;
          
          .slider-wrapper {
            flex: 1;
            
            .usage-slider {
              width: 100%;
              height: 6px;
              -webkit-appearance: none;
              appearance: none;
              background: #E4E7ED;
              border-radius: 3px;
              outline: none;
              
              &::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 18px;
                height: 18px;
                background: #1F8EFF;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.3s ease;
                
                &:hover {
                  transform: scale(1.2);
                }
              }
              
              &::-moz-range-thumb {
                width: 18px;
                height: 18px;
                background: #1F8EFF;
                border-radius: 50%;
                cursor: pointer;
                border: none;
              }
            }
          }
          
          .usage-input-group {
            display: flex;
            align-items: center;
            gap: 0;
            border: 1px solid #E4E7ED;
            border-radius: 4px;
            overflow: hidden;
            
            .usage-btn {
              width: 40px;
              height: 36px;
              border: none;
              background: #F5F7FA;
              color: #666;
              font-size: 18px;
              cursor: pointer;
              transition: all 0.3s ease;
              
              &:hover {
                background: #1F8EFF;
                color: #FFFFFF;
              }
            }
            
            .usage-input {
              width: 80px;
              height: 36px;
              border: none;
              border-left: 1px solid #E4E7ED;
              border-right: 1px solid #E4E7ED;
              text-align: center;
              font-size: 14px;
              color: #333;
              background: #FFFFFF;
            }
          }
        }
        
        .total-price {
          font-size: 22px;
          font-weight: bold;
          color: #E21A81;
        }
        
        ._texttarea {
          width: 500px;
          resize: none;
          border: 1px solid #ddd;
          padding: 10px;
          outline: none;
          font-size: 14px;
          
          &:focus {
            border-color: #1F8EFF;
          }
        }
        
        ._cdk_tips {
          width: 100%;
          text-align: left;
          font-size: 13px;
          margin-top: 20px;
          margin-left: 0;
          color: #999;
        }
        
        .payment-group {
          width: calc(100% - 100px);
          display: flex;
          line-height: 40px;
          
          .payment-item {
            min-width: 140px;
            height: 40px;
            border: 1px solid #DEDEDE;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            margin-right: 20px;
            cursor: pointer;
            
            img {
              width: 27px;
            }
            
            p {
              margin-left: 5px;
              margin: 0;
            }
            
            &:hover {
              border-color: #1F8EFF;
            }
            
            &.active {
              border: 1px solid #1F8EFF;
            }
            
            &.active::after {
              content: '';
              display: inline-block;
              width: 22px;
              height: 22px;
              background: url('../assets/priceb.png') no-repeat;
              background-size: 100%;
              position: absolute;
              right: 0;
              top: -1px;
            }
          }
        }
        
        .submit-row {
          margin-top: 40px;
          text-align: center;
          
          .submit-btn {
            width: 200px;
            height: 44px;
            background: linear-gradient(90deg, #1F8EFF 0%, #51B3FF 100%);
            border: none;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(31, 142, 255, 0.3);
            
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(31, 142, 255, 0.4);
            }
            
            &:active {
              transform: translateY(0);
            }
          }
        }
      }
      
      // 短效优势介绍样式
      ._tabAdvantage {
        width: 100%;
        margin-top: 80px;
        h3 {
          font-size: 36px;
          font-weight: bold;
          &::after {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #51B3FF;
            position: relative;
            top: -5px;
            left: 50px;
          }
          &::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #51B3FF;
            position: relative;
            top: -5px;
            right: 50px;
          }
        }
        ._advantageCont {
          width: 100%;
          margin-top: 50px;
          display: flex;
          align-items: center;
          padding: 50px;
          color: #fff;
          ._advantageCont_left {
            width: 505px;
            height: 354px;
            background: #1F8EFF;
            padding: 80px 0;
            span {
              display: inline-block;
              width: 100%;
              line-height: 30px;
            }
          }
          ._advantageCont_cent {
            width: 186px;
            height: 400px;
            background: #FFC400;
            padding: 60px 70px;
            font-size: 30px;
            line-height: 70px;
          }
          ._advantageCont_right {
            width: 505px;
            height: 354px;
            background: #F0F6FD;
            color: #5C6872;
            padding: 80px 0;
            span {
              display: inline-block;
              width: 100%;
              line-height: 30px;
            }
          }
        }
      }
      
      // 原有独享套餐样式保持不变
      ._tabBotCont2{
        width: 100%;
        height: 100%;
        ._tabList{
          width: 100%;
          display: flex;
          justify-content: space-around;
          ._li{
            width: 224px;
            height: 320px;
            border-radius: 20px;
            box-shadow: 0px 7px 24px 0px #D9E5F1;
            overflow: hidden;
            cursor:pointer;
            ._ttop{
              width: 100%;
              height: 88px;
              span{
                display: inline-block;
                font-size: 48px;
                color: #E21A81;
                font-weight: bold;
                margin-top: 20px;
              }
              ._cc{
                font-size: 16px;
                color: #222121;
              }
            }
            ._ccont{
              width: 100%;
              height: 55px;
              background: #F0F6FD;
              margin-top:10px;
              span{
                display: inline-block;
                width: 100%;
                color: #5C6872;
                font-size: 14px;
              }
              span:nth-child(1){
                color: #222121;
                // font-size: 20px;
                font-size: 14px;
                margin-top: 12px;
              }
              // span:nth-child(2){
              //   font-size: 14px;
              // }
              span._price{
                color: #1F8EFF;
                font-size: 20px;
                font-weight: bold;
              }
            }
            ._bbot{
              width: 100%;
              height: calc(100% - 140px);
              ._lineCount{
                display: block;
                width: 100%;
                text-align: center;
                color: #5C6872;
                font-size: 14px;
                margin-top: 12px;
                margin-bottom: 10px;
              }
              ._num{
                margin-top: 5px;
              }
              ._botton{
                width: 160px;
                height: 45px;
                border-radius: 100px;
                border:1px solid #1F8EFF;
                color: #1F8EFF;
                font-size: 20px;
                font-weight: bold;
                line-height: 45px;
                text-align: center;
                margin: 0 auto;
                margin-top: 15px;
              }
            }
          }
          ._active{
            border: 2px solid #1F8EFF;
            ._bbot{
              ._botton{
                border: none;
                color: #fff;
                background: #1F8EFF;
              }
            }
          }
        }
        ._tabAdvantage{
          width: 100%;
          margin-top: 80px;
          h3{
            font-size: 36px;
            font-weight: bold;
          }
          h3::after{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #51B3FF;
            position: relative;
            top: -5px;
            left: 50px;
          }
          h3::before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #51B3FF;
            position: relative;
            top: -5px;
            right: 50px;
          }
          ._advantageCont{
            width: 100%;
            margin-top: 50px;
            display: flex;
            align-items: center;
            padding: 50px;
            color: #fff;
            ._advantageCont_left{
              width: 505px;
              height: 354px;
              background: #1F8EFF;
              padding: 80px 0 ;
              span{
                display: inline-block;
                width: 100%;
                line-height: 30px;
              }
            }
            ._advantageCont_cent{
              width: 186px;
              height: 400px;
              background: #FFC400;
              padding: 60px 70px;
              font-size: 30px;
              line-height: 70px;
            }
            ._advantageCont_right{
              width: 505px;
              height: 354px;
              background: #F0F6FD;
              color: #5C6872;
              padding: 80px 0 ;
              span{
                display: inline-block;
                width: 100%;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
    
    // 大客户定制样式 - 已隐藏
    /* ._tabBotCont3 {
      width: 100%;
      min-height: 500px;
      
      .enterprise-custom {
        max-width: 800px;
        margin: 0 auto;
        padding: 60px 20px;
        text-align: center;
        
        .custom-icon {
          font-size: 80px;
          margin-bottom: 20px;
        }
        
        h3 {
          font-size: 32px;
          font-weight: bold;
          color: #333;
          margin-bottom: 16px;
        }
        
        .custom-desc {
          font-size: 16px;
          color: #666;
          margin-bottom: 30px;
        }
        
        .custom-list {
          list-style: none;
          padding: 0;
          margin: 0 0 40px 0;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 16px;
          
          li {
            padding: 12px 24px;
            background: rgba(31, 142, 255, 0.05);
            border-radius: 4px;
            color: #1F8EFF;
            font-size: 14px;
          }
        }
        
        .custom-contact {
          p {
            font-size: 14px;
            color: #999;
            margin-bottom: 20px;
          }
          
          .contact-btn {
            width: 200px;
            height: 44px;
            background: linear-gradient(90deg, #1F8EFF 0%, #51B3FF 100%);
            border: none;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(31, 142, 255, 0.3);
            
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(31, 142, 255, 0.4);
            }
          }
        }
      }
    } */
  }
}
@media screen and (max-width: 1200px) {
  .Package{
    .banner{
      width: 1200px;
    } 
  }
}
</style>
idth: 1200px;
    } 
  }
}
</style>
}
    }
  }
}
@media screen and (max-width: 1200px) {
  .Package{
    .banner{
      width: 1200px;
    } 
  }
}
</style>
 
  }
}
</style>
idth: 1200px;
    } 
  }
}
</style>
}
    }
  }
}
@media screen and (max-width: 1200px) {
  .Package{
    .banner{
      width: 1200px;
    } 
  }
}
</style>
